import React, { useEffect, useRef, useState } from 'react';
import { Close, Search } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import styles from '../GeneralSettings.module.scss';

interface CollapsibleUserSearchProps {
	value: string;
	onChange: (value: string) => void;
}

export function CollapsibleUserSearch({ value, onChange }: CollapsibleUserSearchProps) {
	const [expanded, setExpanded] = useState(false);
	const inputRef = useRef<HTMLInputElement>(null);
	const isOpen = expanded || Boolean(value.trim());

	useEffect(() => {
		if (isOpen && inputRef.current) {
			inputRef.current.focus();
		}
	}, [isOpen]);

	const handleClose = () => {
		onChange('');
		setExpanded(false);
	};

	return (
		<div
			className={`${styles.collapsibleSearch} ${isOpen ? styles.collapsibleSearchExpanded : ''}`}
		>
			{!isOpen ? (
				<IconButton
					className={styles.searchToggleButton}
					onClick={() => setExpanded(true)}
					aria-label="Search users"
					size="small"
				>
					<Search fontSize="small" />
				</IconButton>
			) : (
				<TextField
					inputRef={inputRef}
					placeholder="Search users..."
					value={value}
					onChange={(e) => onChange(e.target.value)}
					variant="outlined"
					size="small"
					className={styles.searchInput}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<Search fontSize="small" />
							</InputAdornment>
						),
						endAdornment: (
							<InputAdornment position="end">
								<IconButton
									size="small"
									onClick={handleClose}
									aria-label="Close search"
									edge="end"
								>
									<Close fontSize="small" />
								</IconButton>
							</InputAdornment>
						),
					}}
				/>
			)}
		</div>
	);
}

export default CollapsibleUserSearch;
